/**
 * Configuration object which is consumed by usermanger,
 * the configurations should be in sync with backend.
 */

export const userManagerConfig = () => {
  const url = window.location.origin;
  return {
    client_id: 'onboardingUI',
    accessTokenExpiringNotificationTime: 10,
    post_logout_redirect_uri: `${url}/logoff`,
    redirect_uri: `${url}/sign-in-callback`,
    silent_redirect_uri: `${url}/silent-renewal-callback`,
    response_type: 'code',
    scope: 'openid profile onboarding_api visionplanner_api',
    automaticSilentRenew: true,
    authority: authorizationServerUrl,
    filterProtocolClaims: true,
    loadUserInfo: true,
  };
};
